"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Division {
}
exports.Division = Division;
//# sourceMappingURL=Division.js.map